// extracted by mini-css-extract-plugin
module.exports = {"bannerContainer":"Banner_bannerContainer__l3Kpe","banner":"Banner_banner__NX7Oe"};